import React, { forwardRef, ReactNode } from "react";
import {
  Button as FlowbiteButton,
  ButtonProps,
  CustomFlowbiteTheme,
} from "flowbite-react";

interface CourieButtonProps extends ButtonProps {
  children: ReactNode;
  isProcessing?: boolean;
}

const customTheme: CustomFlowbiteTheme["button"] = {
  color: {
    yellow: "bg-yellow-200 hover:bg-yellow-300 dark:bg-yellow-700 dark:hover:bg-yellow-600 dark:text-gray-100",
    primary: "bg-primary-400 hover:bg-primary-500 dark:bg-primary-600 dark:hover:bg-primary-700 dark:text-white",
    secondary: "bg-gray-100 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100 border",
    link: "bg-transparent border-0 text-blue-600 hover:text-blue-800 hover:underline shadow-none p-0 dark:text-blue-400 dark:hover:text-blue-300",
    success: "bg-green-600 hover:bg-green-700 text-white dark:bg-green-700 dark:hover:bg-green-600",
    failure: "bg-red-600 hover:bg-red-700 text-white dark:bg-red-700 dark:hover:bg-red-600",
    warning: "bg-yellow-400 hover:bg-yellow-500 text-white dark:bg-yellow-600 dark:hover:bg-yellow-500",
    info: "bg-blue-600 hover:bg-blue-700 text-white dark:bg-blue-700 dark:hover:bg-blue-600",
    light: "bg-gray-100 hover:bg-gray-200 text-gray-900 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100",
    dark: "bg-gray-800 hover:bg-gray-900 text-white dark:bg-gray-700 dark:hover:bg-gray-600",
    danger: "bg-red-600 hover:bg-red-700 text-white dark:bg-red-700 dark:hover:bg-red-600",
    gray: "hover:bg-gray-300 dark:hover:bg-gray-600 dark:text-gray-100",
  },
};

const CourieButton = forwardRef<HTMLButtonElement, CourieButtonProps>(
  ({ children, isProcessing, disabled, ...props }, ref) => {
    return (
      <FlowbiteButton
        ref={ref}
        theme={customTheme}
        pill={true}
        isProcessing={isProcessing}
        // Flowbite's `isProcessing` only renders a spinner. `disabled` is
        // destructured out of the spread so a call site passing its own
        // `disabled` can't re-enable the button mid-request.
        disabled={isProcessing || disabled}
        {...props}
      >
        {children}
      </FlowbiteButton>
    );
  }
);

CourieButton.displayName = "CourieButton";

export default CourieButton;
